import React from 'react';
import classNames from 'classnames';
import {
  AvailableIcons,
  Icon,
  Typography,
  TypographyType,
  TypographyVariant,
} from 'src/components-dummy';
import { WIZARD_STEPS } from '../types';
import './WizardStepIndicator.scss';

export interface WizardStepIndicatorProps {
  activeStep: number;
  onStepClick?: (step: number) => void;
}

export const WizardStepIndicator = ({
  activeStep,
  onStepClick,
}: WizardStepIndicatorProps): JSX.Element => {
  return (
    <div className='syte-wizard-step-indicator'>
      {WIZARD_STEPS.map(({ step, label }) => {
        const isDone = step < activeStep;
        const isActive = step === activeStep;

        return (
          <button
            key={step}
            type='button'
            disabled={!onStepClick}
            onClick={() => onStepClick?.(step)}
            className={classNames('syte-wizard-step-indicator-item', {
              'syte-wizard-step-indicator-item-active': isActive,
              'syte-wizard-step-indicator-item-done': isDone,
            })}
          >
            <div className='syte-wizard-step-indicator-item-circle'>
              {isDone ? <Icon name={AvailableIcons.Check} /> : step}
            </div>
            <Typography type={TypographyType.Body} variant={TypographyVariant.SmallRegular}>
              {label}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};
